<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar>
      <v-img
        :src="logo"
      />
    </v-list-item-avatar>

    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h5">
        <strong class="mr-1 font-weight-black">{{ profile.organization.name }}</strong>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'

  export default {
    name: 'DefaultDrawerHeader',

    computed: {
      version: get('app/version'),
      profile: get('auth/profile'),
      logo () { return 'data:image/jpeg;base64,' + (this.profile.organization.avatar ? this.profile.organization.avatar.thumbnail : null) },
    },

    watch: {
      profile: {
        handler () {
          console.log('A profil változott!!!!')
        },
        deep: true,
      },
    },
  }
</script>
